import React from 'react';
import Button from '../../../components/ui/Button';


const BulkActionBar = ({
  selectedCount,
  onBulkApprove,
  onBulkReject,
  onBulkAssign,
  onClearSelection
}) => {
  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center space-x-3">
          <div className="bg-primary text-primary-foreground rounded-full w-8 h-8 flex items-center justify-center text-sm font-medium">
            {selectedCount}
          </div>
          <div>
            <div className="text-sm font-medium text-foreground">
              {selectedCount} {selectedCount === 1 ? 'demanda selecionada' : 'demandas selecionadas'}
            </div>
            <button
              onClick={onClearSelection}
              className="text-xs text-primary hover:underline"
            >
              Limpar seleção
            </button>
          </div>
        </div>

        <div className="flex flex-wrap gap-2">
          <Button
            variant="success"
            size="sm"
            iconName="Check"
            iconPosition="left"
            onClick={onBulkApprove}
          >
            Aprovar Selecionadas
          </Button>
          <Button
            variant="danger"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onBulkReject}
          >
            Rejeitar Selecionadas
          </Button>
          <Button
            variant="default"
            size="sm"
            iconName="UserPlus"
            iconPosition="left"
            onClick={onBulkAssign}
          >
            Atribuir em Lote
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionBar;